var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFilter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.57,
    height: 10.571,
    viewBox: "0 0 10.57 10.571",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "filter_1_",
    "data-name": "filter (1)",
    d: "M10.657,0H.913A.413.413,0,0,0,.5.413,4.033,4.033,0,0,0,1.852,3.424L3.661,5.032a1.471,1.471,0,0,1,.493,1.1v4.027A.413.413,0,0,0,4.8,10.5L7.232,8.877a.413.413,0,0,0,.184-.344v-2.4a1.471,1.471,0,0,1,.493-1.1L9.718,3.424A4.033,4.033,0,0,0,11.07.413.413.413,0,0,0,10.657,0ZM9.169,2.807,7.361,4.415A2.3,2.3,0,0,0,6.59,6.131V8.312L4.98,9.386V6.131a2.3,2.3,0,0,0-.771-1.716L2.4,2.807A3.208,3.208,0,0,1,1.353.826h8.865A3.207,3.207,0,0,1,9.169,2.807Zm0,0",
    transform: "translate(-0.5 0)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.4aa7f92b02496f66e348afac6a4b37c0.svg";
export { ForwardRef as ReactComponent };